import requestUtil from '../../helpers/requestUtil';
import { setLoading } from '../common/Loader/slice';
import * as Toasts from '../common/Toastify';
import {
  deleteEmployerUserError,
  deleteEmployerUserSuccess,
  getLocationDropdownError,
  getLocationDropdownSuccess,
  getUserListError,
  getUserListSuccess,
  getUserTypesError,
  getUserTypesSuccess, setLoadingFlagDecrement, setLoadingFlagIncrement, setUserLoder, setUserMappedLocationData
} from './slice';

export function getUserList(url, userInfo) {

  return async (dispatch) => {
    // dispatch(setUserLoder(true))
    // dispatch(setLoading(true));
    // requestUtil(`${url}/EmployerUsers/getemployeruserlist`, 'POST', userInfo)
    //   .then((response) => {
    //     dispatch(getUserListSuccess(response.employerUsers));
    //     dispatch(setUserLoder(false))
    //   })
    //   .catch((error) => {
    //     dispatch(setUserLoder(false))
    //     dispatch(getUserListError(error.message));
    //     dispatch(setLoading(false));
    //   });
    // dispatch(setLoading(false));
    dispatch(setUserLoder(true))
    dispatch(setLoadingFlagIncrement())
    try {
      const response = await requestUtil(`${url}/EmployerUsers/getemployeruserlist`, 'POST', userInfo);
      dispatch(getUserListSuccess(response.employerUsers));
    } catch(error){
      dispatch(getUserListError(error.message));
    } finally {
      dispatch(setUserLoder(false))
      dispatch(setLoadingFlagDecrement())

    }
  };
}

export function getLocationDropdownList(url, employerId) {
  return async (dispatch) => {
    // dispatch(setLoading(true));
    // requestUtil(
    //   `${url}/Locations/get-location-list-for-dropdown-by-employerid/${employerId}`,
    //   'GET'
    // )
    //   .then((response) => {
    //     dispatch(getLocationDropdownSuccess(response));
    //   })
    //   .catch((error) => {
    //     dispatch(getLocationDropdownError(error.message));
    //     dispatch(setLoading(false));
    //   });
    // dispatch(setLoading(false));
    dispatch(setLoadingFlagIncrement())
    try {
      const response = await requestUtil(
          `${url}/Locations/get-location-list-for-dropdown-by-employerid/${employerId}`,
          'GET'
        );
        dispatch(getLocationDropdownSuccess(response));
    } catch(error){
      dispatch(getLocationDropdownError(error.message));
    } finally {
      dispatch(setLoadingFlagDecrement())
    }
  };
}

export function getUserTypes(url) {
  return async (dispatch) => {
    // dispatch(setLoading(true));
    // requestUtil(`${url}/EmployerUsers/getusertypes`, 'GET')
    //   .then((response) => {
    //     dispatch(getUserTypesSuccess(response));
    //   })
    //   .catch((error) => {
    //     dispatch(getUserTypesError(error.message));
    //     dispatch(setLoading(false));
    //   });
    // dispatch(setLoading(false));
    dispatch(setLoadingFlagIncrement())
    try {
      const response = await requestUtil(`${url}/EmployerUsers/getusertypes`, 'GET')
        dispatch(getUserTypesSuccess(response));
    } catch(error){
      dispatch(getUserTypesError(error.message));
    } finally {
      dispatch(setLoadingFlagDecrement())
    }
  };
}

export function deleteEmployerUser(url, employerUserId, employerId) {
  return async (dispatch) => {
    // dispatch(setLoading(true));
    // requestUtil(
    //   `${url}/EmployerUsers/deleteemployeruser/${employerUserId}`,
    //   'POST'
    // )
    //   .then((response) => {
    //     dispatch(deleteEmployerUserSuccess(response.message));
    //   })
    //   .catch((error) => {
    //     dispatch(deleteEmployerUserError(error.message));
    //     dispatch(setLoading(false));
    //   });
    // dispatch(setLoading(false));
    dispatch(setLoadingFlagIncrement())
    try {
      const response = await requestUtil(
          `${url}/EmployerUsers/deleteemployeruser/${employerUserId}`,
          'POST'
        )
        dispatch(deleteEmployerUserSuccess(response.message));
    } catch(error){
      dispatch(deleteEmployerUserError(error.message));
    } finally {
      dispatch(setLoadingFlagDecrement())
    }
  };
}

export function getUserMappedLocation(url, employerUserId) {
  return async (dispatch) => {
    // dispatch(setLoading(true));
    // requestUtil(
    //   `${url}/EmployerUsers/get-mapped-locations/${employerUserId}`,
    //   'POST'
    // )
    //   .then((response) => {
    //     dispatch(setUserMappedLocationData(response));
    //     dispatch(setLoading(false));
    //   })
    //   .catch((error) => {
    //     dispatch(setLoading(false));
    //   });
    dispatch(setLoadingFlagIncrement())
    try {
      const response = await requestUtil(
          `${url}/EmployerUsers/get-mapped-locations/${employerUserId}`,
          'POST'
        )
        dispatch(setUserMappedLocationData(response));
    } catch(error){
      // dispatch(deleteEmployerUserError(error.message));
      Toasts.error(error.message);
    } finally {
      dispatch(setLoadingFlagDecrement())
    }
  };
}

export function saveUserMappedLocation(url, locationJson) {
  return async (dispatch) => {
    // dispatch(setLoading(true));
    // requestUtil(
    //   `${url}/EmployerUsers/save-user-location-mapping`,
    //   'POST',
    //   locationJson
    // )
    //   .then((response) => {
    //     Toasts.success(response.message);
    //     dispatch(setLoading(false));
    //   })
    //   .catch((error) => {
    //     dispatch(setLoading(false));
    //   });
    dispatch(setLoadingFlagIncrement())
    try {
      const response = await requestUtil(
          `${url}/EmployerUsers/save-user-location-mapping`,
          'POST',
          locationJson
        )
        Toasts.success(response.message);
    } catch(error){
      // dispatch(deleteEmployerUserError(error.message));
      Toasts.error(error.message);
    } finally {
      dispatch(setLoadingFlagDecrement())
    }
  };
}
